module.exports = __webpack_public_path__ + "img/salary.5bb58575.svg";